import { getClientFor } from './getClientFor';
import type { AppContext } from './types/AppContext';
import { reportError } from './reportError';
import { reportMessage } from './reportMessage';
import type { Reporter } from './types/Reporter';

const reporterMap = new Map<string, Reporter>();

export const getReporterFor = (appContext: AppContext): Reporter => {
  const name = appContext.app_name;

  if (reporterMap.has(name)) {
    return reporterMap.get(name)!;
  }

  const client = getClientFor(name);

  const reporter = {
    error: reportError({ appContext, client }),
    info: reportMessage({ appContext, client, level: 'info' }),
    log: reportMessage({ appContext, client, level: 'log' }),
    warn: reportMessage({ appContext, client, level: 'warning' }),
  };

  reporterMap.set(name, reporter);

  return reporter;
};
